<template lang="pug">
  validation-provider(ref="select" :vid="vid" :name="name" :rules="rules" v-slot="{ errors }")
    .form-field
      label.label {{ name }}
      multiselect(
        v-model="innerValue"
        :options="options"
        :multiple="multiple"
        :searchable="searchable"
        :taggable="taggable"
        :show-labels="showLabels"
        :track-by="trackBy"
        :label="label"
        :placeholder="placeholder"
        :deselect-label="deselectLabel"
        :selected-label="selectedLabel"
        :select-label="selectLabel"
        :tag-placeholder="tagPlaceholder"
        :options-limit="optionsLimit"
        :limit="limit"
        :loading="loading"
        :class="{ 'is-danger': errors && errors.length }"
        @search-change="query => $emit('search-change', query)"
        @close="validate"
        @tag="value => $emit('tag', value)"
      )
        template(v-slot:noOptions)
          slot(name="noOptions")
        template(v-slot:noResult)
          slot(name="noResult")
      p.help.is-danger(v-if="errors && errors.length") {{ errors[0] }}
      p.help.has-text-grey(v-else) Pflicht
</template>

<script>
import { ValidationProvider } from "vee-validate";
import Multiselect from "vue-multiselect";

export default {
  props: {
    vid: {
      type: String
    },
    name: {
      type: String,
      default: ""
    },
    rules: {
      type: [Object, String],
      default: ""
    },
    options: {
      type: Array,
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    trackBy: {
      type: String
    },
    label: {
      type: String
    },
    searchable: {
      type: Boolean,
      default: true
    },
    clearOnSelect: {
      type: Boolean,
      default: true
    },
    hideSelected: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: "Select option"
    },
    allowEmpty: {
      type: Boolean,
      default: true
    },
    resetAfter: {
      type: Boolean,
      default: false
    },
    closeOnSelect: {
      type: Boolean,
      default: true
    },
    customLabel: {
      type: Function
    },
    taggable: {
      type: Boolean,
      default: false
    },
    tagPlaceholder: {
      type: String,
      default: "Press enter to create a tag"
    },
    tagPosition: {
      type: String,
      default: "top"
    },
    max: {
      type: Number
    },
    optionsLimit: {
      type: Number,
      default: 1000
    },
    groupValues: {
      type: String,
      default: ""
    },
    groupLabel: {
      type: String,
      default: ""
    },
    groupSelect: {
      type: Boolean,
      default: false
    },
    blockKeys: {
      type: Array,
      default: () => {
        return [];
      }
    },
    internalSearch: {
      type: Boolean,
      default: true
    },
    preserveSearch: {
      type: Boolean,
      default: false
    },
    preselectFirst: {
      type: Boolean,
      default: false
    },
    selectLabel: {
      type: String,
      default: "Press enter to select"
    },
    selectGroupLabel: {
      type: String,
      default: "Press enter to select group"
    },
    selectedLabel: {
      type: String,
      default: "Selected"
    },
    deselectLabel: {
      type: String,
      default: "Press enter to remove"
    },
    deselectGroupLabel: {
      type: String,
      default: "Press enter to deselect group"
    },
    showLabels: {
      type: Boolean,
      default: true
    },
    limit: {
      type: Number,
      default: 99999
    },
    limitText: {
      type: Function
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxHeight: {
      type: Number,
      default: 300
    },
    openDirection: {
      type: String,
      default: ""
    },
    showNoResults: {
      type: Boolean,
      default: true
    },
    tabindex: {
      type: Number,
      default: 0
    },
    showPointer: {
      type: Boolean,
      default: true
    },
    optionHeight: {
      type: Number,
      default: 40
    },
    // must be included in props
    value: {
      type: null
    }
  },
  data: () => ({
    innerValue: ""
  }),
  components: {
    ValidationProvider,
    Multiselect
  },
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit("input", newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    }
  },
  methods: {
    validate() {
      if (
        this.$refs.select.mode === "aggressive" ||
        this.$refs.select.mode === "lazy"
      ) {
        this.$refs.select.validate();
      }
    }
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  }
};
</script>
